import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
import { getMembers, getCityCouncil, getCityCouncilByYear } from '../service/service';
import SakrebuloCard from './SakrebuloCard';

function SakrebuloMembers() {
	const ref = useRef(null);
	const [width, setWidth] = useState(10);
	const { search } = useContext(SearchContext);
	const { language } = useContext(SearchContext);
	const [wevrebi, setWevrebebi] = useState([]);
	const [members, setMembers] = useState({});
	const [years, setYears] = useState([]);
	const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
	
	useEffect(() => {
		const link = `https://khulo.gov.ge/api/members.php?`;
		fetch(link)
			.then(response => response.json())
			.then(data => {
				setMembers(data);
			});
	}, []);

	const [menu, setMenu] = useState({});
	useEffect(() => {
		const link = 'https://khulo.gov.ge/api/site_menu1.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				// console.log('data.menu',data.menu)
				setMenu(data.menu);

				//  console.log('menu', menu)

				//  console.log('object entries', Object.entries(menu))

				Object.entries(menu).map(item => {
					if (item[1].level == 1) {
						//console.log('entries item', item[1].name_eng , item[1].level)
					}
				});
			});
	}, []);
	const presscenterList = Object.entries(menu).length
		? Object.entries(menu).map((item, index) => {
				if (item[1].level == 1 && item[1].name_geo == 'საკრებულო') {
					return Object.entries(menu).map((qveItem, index) => {
						if (qveItem[1].parent_id == item[1].cat_id) {
							const windoww = window.location.pathname;
							const result = windoww.split('/').pop();
							const slugg = qveItem[1].slug;
							return (
								<span key={index} className={result === slugg ? 'active' : ''}>
									<Link to={`/${qveItem[1].slug}`}>
										{language == 1 ? qveItem[1].name_geo : qveItem[1].name_eng}
									</Link>
								</span>
							);
						}
					});
				}
		  })
		: 'LOADING';

	const [membersList, setMembersList] = useState([]);
	useEffect(() => {
		const uniqueMembers = new Map();

		Object.entries(members)
			.sort((a, b) => b[1].geo.date.localeCompare(a[1].geo.date))
			.filter(news => news[1].geo.title.includes(search))
			.forEach(news => {
				const title = news[1].geo.title;
				const position = news[1].geo.position;
				const isPreferredPosition = position.includes('საკრებულოს წევრი');
				const isRelevantPosition =
					position.includes('საკრებულოს წევრი') ||
					position.includes('საკრებულოს თავჯდომარე') ||
					position.includes('საკრებულოს თავმჯდომარის მოადგილე') ||
					position.includes('საკრებულოს თავჯდომარის პირველი მოადგილე');

				// Only process news items with relevant positions
				if (isRelevantPosition) {
					// If the title already exists, prioritize 'საკრებულოს წევრი'
					if (uniqueMembers.has(title)) {
						if (isPreferredPosition) {
							uniqueMembers.set(title, news);
						}
					} else {
						// Otherwise, add the title if it hasn't been added
						uniqueMembers.set(title, news);
					}
				}
			});

		const updatedMembersList = Array.from(uniqueMembers.values()).map(news => (
			<div className='landing-items-container-infos' id={news[0]} key={news[0]}>
				<Link to={`/sakrebuloMembers/${news[0]}`}>
					<div className='new-image-wrapp'>
						<img src={'https://khulo.gov.ge/' + news[1].geo.img} alt='' />
					</div>
					<div>
						<span className='time'>
							{language == 1 ? news[1].geo.title : news[1].eng.title}
						</span>
						<span className='header'>
							{language == 1 ? news[1].geo.position : news[1].eng.position}
						</span>
					</div>
				</Link>
			</div>
		));

		setMembersList(updatedMembersList);
	}, [members, search, language]);

	useLayoutEffect(() => {
		setWidth(ref.current.offsetWidth);
	});
	const menuName = Object.entries(menu).length
		? Object.entries(menu).find((item, index) => {
				const windoww = window.location.pathname;
				const result = windoww.split('/').pop();
				const slugg = item[1].slug;
				if (result === slugg) {
					return language == 1 ? item[1].name_geo : item[1].name_eng;
				}
		  })
		: '';

	const membersFc = async () => {
		await getMembers().then(data => {
			setWevrebebi(data);
		});
	};

	useEffect(() => {
		membersFc();
	}, []);

	useEffect(() => {
		getCityCouncil().then(data => {
			setYears(data);
		});
	}, []);


	const handleYearClick = (year) => {
		setSelectedYear(year);
		
	}
	useEffect(() => {
		if (selectedYear) {
			getCityCouncilByYear(selectedYear).then(data => {
				setWevrebebi(data.results);
			});
		}
	}, [selectedYear]);
	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				
				<header>
					<span className='big' ref={ref} style={{ marginRight: width / 2 }}>
						{' '}
						{language == 1 ? 'საკრებულო' : 'KHULO CITY ASSEMBLY'}
					</span>
					<span>
						{menuName
							? language == 1
								? menuName[1].name_geo
								: menuName[1].name_eng
							: ''}
					</span>
				</header>
				<ul className='years--filter__container' style={{ marginLeft: 0 }}>
					{years.map((year) => (		
						<li
							key={year.id}
							onClick={() => handleYearClick(year.start_date)}
							className={year.start_date === selectedYear ? 'active' : ''}
						>
						{year.name}
						</li>
					))}
			    </ul>
					
				<div>
					
					<div className='sakrebulo-landing'>
						<div className='landing-container'>
				
							{wevrebi ? (
								wevrebi.map((item, index) => (
									<SakrebuloCard
										key={index}
										slug={item?.slug}
										image={item?.image}
										full_name={item?.full_name}
										position={item?.position?.position}
										url={'sakrebuloMembers'}
									/>
								))
							) : (
								<h1>LOADING</h1>
							)}
						</div>
					</div>
					<div className='presscenter-info'>{presscenterList}</div>
				</div>
			</div>
		</motion.div>
	);
}

export default SakrebuloMembers;
